<template>
  <v-card
      v-if="content && Item"
  >
    <v-card-title>
      <span
          class="text-truncate"
          style="max-width: 900px"
      >
        {{ Item.orderNumber }}
      </span>

      <v-spacer/>

      <v-btn
          :icon="true"
          :outlined="true"
          color="primary"
          to="/items"
      >
        <v-icon>
          mdi-reply
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <ItemMutations
              :Item="Item"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <v-progress-circular
      v-else
      :indeterminate="true"
  />
</template>

<script>
  import Items from '@/services/items'

  import ItemMutations from '@/components/Item/ItemMutations'

  export default {
    name: 'Item',
    components: {
      ItemMutations
    },
    data() {
      return {
        content: false,
        loading: false,
        Item: null
      }
    },
    metaInfo() {
      return {
        title: (
          this.Item
            ? this.Item.orderNumber
            : ''
        )
      }
    },
    mounted() {
      this.init()
    },
    watch: {
      $route(to, from) {
        if (to.path !== from.path) {
          this.init()
        }
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      refresh() {
        this.loadData('loading', true)
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Položky',
              to: '/items'
            }
          ]
        })
      },
      loadData(key = 'content', value = false) {
        this[key] = value

        Items
          .read({
            id: this.$route.params.id
          })
          .then((response) => {
            this.setBreadcrumbs()

            this.$store.dispatch('layout/addBreadcrumbs', {
              breadcrumbs: [
                {
                  text: response.data.data.Item.orderNumber,
                  to: '/item/' + response.data.data.Item.id
                }
              ]
            })

            this.Item = response.data.data.Item
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.$router.replace('/items')

                break
            }
          })
          .finally(() => {
            this[key] = !value
          })
      }
    }
  }
</script>
